const subscription = {
    limit_exceeded: 'Has alcanzado el límite de tu plan de suscripción.',
    get_plan_failed: 'No se pudo obtener el plan de suscripción para el inquilino.',
    tenant_suspended: 'El inquilino está suspendido. Por favor, contacta con tu administrador.',
};
export default Object.freeze(subscription);
